module.exports = __webpack_public_path__ + "img/booth-yamahaday.67004aba.jpg";